import config from '@babel/core/lib/config'
import { graphql, useStaticQuery } from 'gatsby'
import * as React from 'react'
import { Helmet } from 'react-helmet'

export type SeoProps = {
  description?: string
  url?: string
  lang?: string
  meta?: Meta
  title?: string
}

export type Meta = ConcatArray<PropertyMetaObj | NameMetaObj>

export type PropertyMetaObj = {
  property: string
  content: string
}

export type NameMetaObj = {
  name: string
  content: string
}

const titlePlaceholder = 'PDF Tools AG'

export const Seo = ({ description = '', lang = 'default', meta = [], title = titlePlaceholder, url }: SeoProps) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            siteUrl
          }
        }
      }
    `,
  )

  const ogDescription = site.siteMetadata.description
  const realDescription = description?.length ? description : site.siteMetadata.description

  const ogTitle = site.siteMetadata?.title || titlePlaceholder
  const realTitle = title?.length ? title : titlePlaceholder

  const realLang = lang === 'default' ? 'en' : lang

  return (
    <Helmet
      htmlAttributes={{
        lang: realLang,
      }}
      title={realTitle || ''}
      // titleTemplate={`%s | ${defaultTitle}`}
      link={[
        { rel: 'apple-touch-icon', sizes: '180x180', href: '/apple-touch-icon.png' },
        { rel: 'icon', type: 'image/png', sizes: '32x32', href: '/favicon-32x32.png' },
        { rel: 'icon', type: 'image/png', sizes: '16x16', href: '/favicon-16x16.png' },
        { rel: 'manifest', href: '/site.webmanifest' },
        { rel: 'mask-icon', href: '/safari-pinned-tab.svg', color: '#5bbad5' },
      ]}
      meta={[
        {
          name: `description`,
          content: realDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          ...(url && {
            property: `og:url`,
            content: `${site.siteMetadata.siteUrl}/${url}`,
          }),
        },
        {
          property: `og:locale`,
          content: realLang,
        },
        {
          property: `og:title`,
          content: ogTitle,
        },
        {
          property: `og:description`,
          content: ogDescription,
        },
        {
          property: `og:image`,
          content: `/og-image.png`,
        },
        {
          property: `og:image:width`,
          content: `1280`,
        },
        {
          property: `og:image:height`,
          content: `720`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata?.author || ``,
        },
        {
          name: `twitter:title`,
          content: realTitle,
        },
        {
          name: `twitter:description`,
          content: realDescription,
        },
        {
          name: `msapplication-TileColor`,
          content: '#ffffff',
        },
        {
          name: `theme-color`,
          content: '#ffffff',
        },
        {
          name: 'google-site-verification',
          content: 'NM_MQPqhrSJM4Ve5G6Kb3_eoV1-0BIRwlXLc-nc4fXI'
        }
      ].concat(meta)}
    ></Helmet>
  )
}
